// extracted by mini-css-extract-plugin
module.exports = {"main_page":"Temp_main_page__3GqmU","main_header":"Temp_main_header__kfOxz","content":"Temp_content__1Nzt4"};